import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import { apiSignupForNewsletter } from "Root/api/apiCheckout";
import RegFont from "Root/profile/components/common/RegFont";
// import { postRequestAsync } from "Root/api/httpHelpers";
import toastService from "Root/profile/toastService";
import { validateEmail } from "Root/quiz/components/emailSignUp/emailSignUp";
import styles from "./styles.module.css";
function FooterEmailInput() {
    const [email, setEmail] = useState("");
    const [disabled, setDisabled] = useState(true);
    const onChangeEmail = (e) => {
        setEmail(e.target.value);
        if (validateEmail(e.target.value)) {
            setDisabled(false);
        }
        else {
            setDisabled(true);
        }
    };
    const newsletter_signup = async () => {
        try {
            await apiSignupForNewsletter({ email });
            toastService.successMessage("Success");
        }
        catch (err) {
            toastService.errorMessage("Something went wrong");
        }
    };
    // const newsletter_signup = async () => {
    //   // tested 405 Method Not Allowed
    //   try {
    //     await postRequestAsync(endpoints.signupForNewsletter, {
    //       email,
    //     });
    //     toastService.successMessage("Success");
    //   } catch (e) {
    //     toastService.errorMessage("Something went wrong");
    //   }
    // };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.footer_main_input_container_mob, children: [_jsx("div", { className: `${styles.footer_input_title} ${styles.footer_input_title_mob}`, children: _jsx(RegFont, { color: "#fff", children: "Sign up to receive The Rundown, Gainful's monthly newsletter" }) }), _jsxs("form", { className: styles.footer_input_container, children: [_jsx("input", { type: "text", placeholder: "Enter Email", onChange: onChangeEmail, className: styles.footer_input }), _jsx("button", { type: "button", className: `${disabled ? styles.footer_input_btn_disabled : ""} ${styles.footer_input_btn}`, onClick: newsletter_signup, children: "Enter" })] })] }), _jsxs("div", { className: styles.footer_main_input_container, children: [_jsx("div", { className: `${styles.footer_input_title} ${styles.footer_input_title_mob}`, children: _jsx(RegFont, { color: "#fff", children: "Sign up to receive The Rundown, Gainful's monthly newsletter" }) }), _jsxs("form", { className: styles.footer_input_container, children: [_jsx("input", { type: "text", placeholder: "Enter Email", onChange: onChangeEmail, className: styles.footer_input }), _jsx("button", { type: "button", className: `${disabled ? styles.footer_input_btn_disabled : ""} ${styles.footer_input_btn}`, onClick: newsletter_signup, children: "Enter" })] })] })] }));
}
export default FooterEmailInput;
